import { ConnectJournalConstants } from './ConnectJournal.constants';
import { apiServices } from 'redux/utils/api_services';
import { getDataFromApiAction } from 'components/Atoms/GraasApiUtility/GraasApiUtility.action';
import { forEach as _forEach, isEmpty as _isEmpty } from 'lodash-es';

const formatDateTime = inputTimestamp => {
  // Parse the input timestamp into a Date object
  const date = new Date(inputTimestamp);

  // Extract day, month, year, hours, and minutes
  const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const getConnectJournalData = (payload, from) => {
  return async dispatch => {
    try {
      dispatch({
        type:
          from === 'workspace'
            ? ConnectJournalConstants.GET_CONNECT_JOURNAL_WORKSPACE_REQUEST
            : ConnectJournalConstants.GET_CONNECT_JOURNAL_GLOBAL_REQUEST
      });
      const apiUrl = `${apiServices['sphere']}/data/connectJournal/summary`;
      const apiData = await getDataFromApiAction(apiUrl, payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        let data = apiData?.data || [];
        let formattedData = {};
        let lastUpdatedChannelList = [];
        let inProgressDataAvailable = false;
        _forEach(data, obj => {
          if (obj?.ALICE_METRIC_STATUS === 'In Progress' && !inProgressDataAvailable) {
            inProgressDataAvailable = true;
          }
          if (obj?.ALICE_METRIC_STATUS === 'Incomplete') {
            let nonSyncedMetrics = [];
            const metrics = JSON.parse(obj?.ALICE_METRIC_NAME);
            _forEach(metrics, metric => {
              nonSyncedMetrics?.push(metric?.metric_name);
            });
            formattedData[obj?.CHANNEL] = nonSyncedMetrics;
            lastUpdatedChannelList?.push({
              nickNameID: obj?.CHANNEL,
              lastReportUpdatedTime: obj?.ALICE_METRIC_UPDATED_TIME
                ? formatDateTime(obj?.ALICE_METRIC_UPDATED_TIME)
                : 'NA'
            });
          }
        });
        dispatch({
          type:
            from === 'workspace'
              ? ConnectJournalConstants.GET_CONNECT_JOURNAL_WORKSPACE_SUCCESS
              : ConnectJournalConstants.GET_CONNECT_JOURNAL_GLOBAL_SUCCESS,
          payload: formattedData,
          list: lastUpdatedChannelList,
          isDataAvailable: apiData?.isDataAvailable,
          inProgressDataAvailable: inProgressDataAvailable
        });
      }
    } catch (error) {
      dispatch({
        type:
          from === 'workspace'
            ? ConnectJournalConstants.GET_CONNECT_JOURNAL_WORKSPACE_ERROR
            : ConnectJournalConstants.GET_CONNECT_JOURNAL_GLOBAL_ERROR
      });
    }
  };
};
